import { useLocation } from 'react-router-dom'
import { useBackgroundNavigate } from '@shared/hooks'
import { MouseEvent, useCallback, useMemo } from 'react'

export const useCloseModal = () => {
  const navigate = useBackgroundNavigate()
  const location = useLocation()

  const canGoBack = useMemo(() => !!location.state?.previousLocation, [location.state?.previousLocation])

  const onClose = useCallback(
    (fallbackUrl: string) => {
      if (location.state?.background) {
        navigate(location.state.background)
      } else {
        navigate(fallbackUrl)
      }
    },
    [navigate, location.state?.background],
  )

  const onBack = useCallback(
    (event?: MouseEvent) => {
      event?.stopPropagation()
      if (location.state?.previousLocation) {
        navigate(location.state.previousLocation)
      }
    },
    [navigate, location.state?.previousLocation],
  )

  return { onClose, onBack, canGoBack }
}
